import { importAll } from '@/utils'
import { COMPONENTS_ROUTER_LIST } from '@/noSAAS/pages'
import { mergeNoSAASRouter } from '@/noSAAS/utils'
const routers = {}
const NOSAAS_PAGES = COMPONENTS_ROUTER_LIST[process.env.VUE_APP_COMPANY_ID] || null
// console.log('vue-router',process.env.VUE_APP_COMPANY_ID)

importAll(require.context('./', true, /\.js$/), (key, r) => {
  const keyPath = key.match(/\.\/(.+)\.js$/)[1]
  if (!['index'].includes(keyPath)) {
    // console.log('vue-router-key',key)
    let _router = r(key).default ? r(key).default : r(key)
    routers[keyPath] = NOSAAS_PAGES ? mergeNoSAASRouter(_router, key, NOSAAS_PAGES) : _router
  }
})
export default {
  ...routers
}
